
import { useEffect } from "react";
import ContactDate from "./component/ContactDate";
import ContactForm from "./component/ContactForm";
import ContactHero from "./component/ContactHero";
import ImmigrationMap from "./component/ImmigrationMap";

export default function ContactUs() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"     // smooth scroll to top
        });
    }, []);

    return (

        <>

            <ContactHero />
            <ImmigrationMap />
            <ContactForm />
            <ContactDate />


        </>
    )
}